import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import { getBodyInsuranceOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyInsurance/getBodyInsuranceOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
export default () => {
  return <ShowBodyInsurance />;
};
const ShowBodyInsurance = () => {
  const { id } = useParams();
  const { data } = useQuery(getBodyInsuranceOptions({ id: +id! }));

  const showData = [
    [
      {
        label: 'بیمه گر',
        value: data?.insurance_body_info?.insurance?.name?.toString() || '',
      },
      {
        label: 'شماره بیمه',
        value: data?.insurance_body_info?.insurance_number?.toString() || '',
      },
      {
        label: 'تاریخ شروع',
        value: data?.insurance_body_info?.insurance_start_date
          ? convertTimestampToShamsi(
              data?.insurance_body_info?.insurance_start_date,
            )
          : '',
      },
      {
        label: 'تاریخ انقضا',
        value: data?.insurance_body_info?.insurance_expiry_date
          ? convertTimestampToShamsi(
              data?.insurance_body_info?.insurance_expiry_date,
            )
          : '',
      },
    ],
    [
      {
        label: 'بیمه گر',
        value: data?.insurance_property_info?.insurance?.name?.toString() || '',
      },
      {
        label: 'شماره بیمه',
        value:
          data?.insurance_property_info?.insurance_number?.toString() || '',
      },
      {
        label: 'تاریخ شروع',
        value: data?.insurance_property_info?.insurance_start_date
          ? convertTimestampToShamsi(
              data?.insurance_property_info?.insurance_start_date,
            )
          : '',
      },
      {
        label: 'تاریخ انقضا',
        value: data?.insurance_property_info?.insurance_expiry_date
          ? convertTimestampToShamsi(
              data?.insurance_property_info?.insurance_expiry_date,
            )
          : '',
      },
      {
        label: 'تاریخ انقضا بیمه نامه سال قبل',
        value: data?.insurance_property_info?.insurance_expiry_date_last_year
          ? convertTimestampToShamsi(
              data?.insurance_property_info?.insurance_expiry_date_last_year,
            )
          : '',
      },
    ],
  ];
  return (
    <Box
      className={css({
        paddingTop: '24px',
        paddingBottom: '24px',
      })}
    >
      <Flex gap={'1rem'} flexDirection={'column'}>
        {showData?.map((item, index) => (
          <ShowIncidentParticipantsDataCard
            key={`index-${index}`}
            data={item}
            title={index === 0 ? 'اطلاعات بیمه بدنه' : 'اطلاعات بیمه شخص ثالث'}
          />
        ))}
      </Flex>
    </Box>
  );
};
